{
  "completed": "Završeno: ",
  "current": "Trenutno: ",
  "notCompleted": "Nije završeno: ",
  "steplist": "Lista koraka"
}
